import { render, staticRenderFns } from "./tourists.vue?vue&type=template&id=a1983980&"
import script from "./tourists.vue?vue&type=script&lang=js&"
export * from "./tourists.vue?vue&type=script&lang=js&"
import style0 from "./tourists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports